export const CellWithoutContent = () => {
  return <div></div>
}
